import { LanguageProvider } from "../core/language-provider";

export const baseValidation = {
  required: {
    value: true,
    message: LanguageProvider.get("login.required"),
  },
};
